<template>
  <div>
    <div class="card modal-card">
      <div class="modal-card-body pd-0">
        <header class="bandeau-modal card-header">
        </header>
        <div class="center">
          <div class="columns is-gapless">
            <div class="column mgt-20px">
              <h1 class="title is-size-3">{{ $t('listeCommandeCommissions.history.title') }}</h1>
            </div>
          </div>
        </div>
        <div class="card-content">
          <v-client-table :data=history :columns="columns" :options="options"
                          ref="tableHistory">
            <div slot="code" slot-scope="props">
              {{ props.row.code }}
            </div>
            <div slot="etat" slot-scope="props">
              {{ $t(getEtatCommande(props.row.etat)) }}
              - {{ props.row.lastModificationTime | formatDate }}
            </div>
            <div slot="creator" slot-scope="props">
              {{ getUser(props.row.creatorUserId) }}
            </div>
            <div slot="montant" slot-scope="props">
              {{ props.row.montantHt | formatDevise }}
            </div>
            <div slot="date" slot-scope="props">
              {{ props.row.dateDevisCommande | formatDate }}
            </div>
          </v-client-table>
          <div class="center mgt-20px">
            <div class="button" @click="$parent.close()">
              {{ $t('general.button.close') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllForDevisCommandeFactureAsync } from '@/api/commissionVendeur';
import { createNamespacedHelpers } from 'vuex';
import * as devisConf from '@/configuration/devisConf';
import messageErreur from '@/services/general/messageErreur';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_POP_UP,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'historyCommandeCommission',
  props: {
    idCommandeVente: {
      required: false,
    },
    commande: {
      type: Object,
      required: true,
    },
    isForCommericaux: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      history: [],
    };
  },
  methods: {
    getUser(userId) {
      const userFound = this.users.find((user) => { return user.id === userId; });
      if (!userFound) return 'support@quadra-diffusion.fr';
      return nomPrenomGetter(userFound);
    },
    getEtatCommande(etat) {
      return FACTURE_ETAT.find((etatInList) => {
        return etatInList.code === etat;
      }).libelle;
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeCommandeCommissions.history.table.code'),
          etat: this.$t('listeCommandeCommissions.history.table.etat'),
          creator: this.$t('listeCommandeCommissions.history.table.creator'),
          montant: this.$t('listeCommandeCommissions.history.table.montant'),
          date: this.$t('listeCommandeCommissions.history.table.date'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        sortable: ['code', 'etat'],
      };
    },
    columns() {
      return ['code', 'date', 'etat', 'creator', 'montant'];
    },
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.isForCommericaux) {
        this.history = (await getAllForDevisCommandeFactureAsync({
          query: {
            societeId: this.societeActiveId,
            etat: [devisConf.ETAT_ANNULER],
            tiersId: [this.commande.intervenants[0].tiersId],
            type: devisConf.TYPE_FACTURE,
            referenceIds: [this.commande.id],
          },
        }, this.idCommandeVente)).data.result.items;
      } else {
        this.history = (await getAllForDevisCommandeFactureAsync({
          query: {
            societeId: this.societeActiveId,
            etat: [devisConf.ETAT_ANNULER],
            tiersId: [this.commande.intervenants[0].tiersId],
            type: devisConf.TYPE_FACTURE,
            referenceIds: [this.commande.id],
          },
        }, this.idCommandeVente)).data.result.items;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
